export default "__VITE_ASSET__B4Fb6vRi__"